import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls"];
import React from 'react';
import { RadioAbstract } from '@uiw/react-radio';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-switch'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(RadioAbstract, _extends({
    prefixCls: prefixCls
  }, _extends({}, other, {
    type: 'checkbox'
  }), {
    ref: ref
  }));
});